<ng-template
	#statusTpl
	let-status
	let-endDate="endDate"
>
	<span
		class="ck-badge text-uppercase"
		[attr.data-color]="utils.getStatusColor(status)"
	>
		@if (status === "EXTRA") {
			<countdown
				[deadline]="endDate"
				[timeOffset]="timeOffset"
			/>
		} @else {
			{{ status | clkBizCT: "AUCTION_STATUS" }}
		}
	</span>
</ng-template>
@let auctionStatus = utils.isExtraTime(auction) && anyExtraLots() ? "EXTRA" : auction.status;
@let noDamage = ["PT", "PL", "LU"].includes(auction.idMarket);
@let noOffers = ["ES", "LU"].includes(auction.idMarket);
@let itsBlind = auction.type === "BLIND";
<section class="row g-0 my-3">
	<div class="col-1 col-lg-3">
		<a
			routerLink="/private/auction-details"
			[queryParams]="{ idAuction: auction?.idAuction }"
			class="text-uppercase text-basecolor fw-bold"
		>
			<span class="simple-arrow simple-arrow-left d-lg-inline-block align-middle"></span>
			<span class="d-none d-lg-inline">
				{{ "auction.live.comeBack" | translate }}
			</span>
		</a>
	</div>
	<div class="col-11 col-lg-9 pt-2 text-end">
		<aside
			class="ck-badge text-uppercase"
			[attr.data-color]="utils.getStatusColor(auctionStatus, 'auction')"
		>
			{{ auctionStatus | clkBizCT: "AUCTION_STATUS" }}
		</aside>
		@if (itsBlind) {
			<aside
				class="ck-badge text-uppercase ms-3"
				[style.backgroundColor]="'#1b4db0'"
			>
				{{ "auctions.blind" | translate }}
			</aside>
		}
		<h3 class="d-inline ms-4 mb-0 align-middle text-blue fw-bold">{{ auction?.auctionName }}</h3>
	</div>

	<div class="col-12 offset-lg-3 col-lg-9 py-2 text-center text-lg-end text-uppercase pt-3 stickyTop-l1 stickyTop-l2 bg-lightgray gray-shadow">
		<countdown
			[deadline]="auction.endDate"
			[timeOffset]="timeOffset"
			(expired)="closeAuction()"
			[fullView]="true"
		/>
	</div>
	<div class="col-12 offset-lg-3 col-lg-9 text-end">
		<button
			type="button"
			class="btn btn-transparent d-none d-lg-inline"
			(click)="detailsOpen = !detailsOpen"
		>
			{{ (detailsOpen ? "auction.live.hideDetails" : "auction.live.showDetails") | translate }}
		</button>
		<button
			type="button"
			class="btn btn-transparent d-lg-none"
			(click)="openTemplateModal(detailsTmp)"
		>
			{{ (detailsOpen ? "auction.live.hideDetails" : "auction.live.showDetails") | translate }}
		</button>
	</div>
	<ng-template #detailsTmp>
		<div
			class="text-start d-grid pt-1 px-3 pb-2 p-lg-0"
			animate.enter="accordion-enter"
			animate.leave="accordion-leave"
		>
			<button
				type="button"
				class="close-x position-absolute top-0 end-0 mt-3 me-3 d-lg-none"
				(click)="closeTemplateModal()"
			></button>
			<div
				class="py-3 pt-lg-0 pb-lg-4"
				[style.minHeight]="0"
			>
				<h4 class="text-blue fw-bold text-big">{{ "auction.details.title" | translate }}</h4>
				<aside class="before-ico ico-flag-{{ auction.idMarket.toLowerCase() }} text-red fw-bold text-sm">{{ `menu.country${auction.idMarket}` | translate | uppercase }}</aside>
				<auction-header [auction]="auction" />
			</div>
		</div>
	</ng-template>
	@if (detailsOpen) {
		<ng-container *ngTemplateOutlet="detailsTmp" />
	}

	@if (singleLot?.length) {
		<article
			[mfData]="singleLot"
			#mf="appDataTable"
			[mfSortBy]="tableDataSingle.orderBy"
			(mfSortByChange)="saveOrderBy(false, $event)"
			[mfSortOrder]="tableDataSingle.sortOrder"
			(mfSortOrderChange)="saveSortOrder(false, $event)"
		>
			@let noFieldSelected = !tableDataSingle.orderBy;
			<header
				class="car-list-heading live-auction sticky-list-heading stickyTop-l3 bg-white rounded-top-3 ck-fixed-shadow mb-3 px-3 d-none d-lg-grid"
				[ngClass]="{
					'car-item-nodamage': noDamage,
					'car-item-nooffers': noOffers,
					'car-item-blind': itsBlind
				}"
			>
				<div class="py-1 min-width-0">
					@let showStatusTriangle = noFieldSelected || tableDataSingle.orderBy === "lotDTO.calculatedStatus";
					<app-default-sorter
						by="lotDTO.calculatedStatus"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.status' | translate"
						[class.pe-4]="showStatusTriangle"
					>
						{{ "auction.details.status" | translate }}
						@if (showStatusTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				<div class="py-1 min-width-0">
					@let showBrandTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.brand";
					<app-default-sorter
						by="vehicle.brand"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.brand' | translate"
						[class.pe-4]="showBrandTriangle"
					>
						{{ "auction.details.brand" | translate }}
						@if (showBrandTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				<div class="py-1 min-width-0">
					@let showModelTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.model";
					<app-default-sorter
						by="vehicle.model"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.model' | translate"
						[class.pe-4]="showModelTriangle"
					>
						{{ "auction.details.model" | translate }}
						@if (showModelTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				<div class="py-1 min-width-0">
					@let showYearTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.yearMatriculation";
					<app-default-sorter
						by="vehicle.yearMatriculation"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.year' | translate"
						[class.pe-4]="showYearTriangle"
					>
						{{ "auction.details.year" | translate }}
						@if (showYearTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				<div class="py-1 min-width-0">
					@let showKmTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.kilometers";
					@let milesOrKm = auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers";
					<app-default-sorter
						by="vehicle.kilometers"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="milesOrKm | translate"
						[class.pe-4]="showKmTriangle"
					>
						{{ milesOrKm | translate }}
						@if (showKmTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>

				@if (!noDamage) {
					<div class="py-1 min-width-0">
						@let showDamageTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.damaged";
						<app-default-sorter
							by="vehicle.damaged"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.details.damage' | translate"
							[class.pe-4]="showDamageTriangle"
						>
							{{ "auction.details.damage" | translate }}
							@if (showDamageTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				}
				<div class="py-1 min-width-0">
					@let showAreaTriangle = noFieldSelected || tableDataSingle.orderBy === "vehicle.locateArea";
					<app-default-sorter
						by="vehicle.locateArea"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.locateArea' | translate"
						[class.pe-4]="showAreaTriangle"
					>
						{{ "auction.details.locateArea" | translate }}
						@if (showAreaTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				@if (!(noOffers || itsBlind)) {
					<div class="py-1 min-width-0">
						@let showOffersTriangle = noFieldSelected || tableDataSingle.orderBy === "lotDTO.acceptedOffers";
						<app-default-sorter
							by="lotDTO.acceptedOffers"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.details.offerNumber' | translate"
							[class.pe-4]="showOffersTriangle"
						>
							{{ "auction.details.offerNumber" | translate }}
							@if (showOffersTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				}
				@if (!itsBlind) {
					<div class="py-1 min-width-0">
						@let showDateTriangle = noFieldSelected || tableDataSingle.orderBy === "lotDTO.dateLastOffer";
						<app-default-sorter
							by="lotDTO.dateLastOffer"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.live.offerDate' | translate"
							[class.pe-4]="showDateTriangle"
						>
							{{ "auction.live.offerDate" | translate }}
							@if (showDateTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				}
				<div class="py-1 min-width-0">
					@let targetPrice = itsBlind ? "startPrice" : "actualPrice";
					@let showPriceTriangle = noFieldSelected || tableDataSingle.orderBy === targetPrice;
					<app-default-sorter
						[by]="targetPrice"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="(itsBlind ? 'auction.live.startPrice' : 'auction.details.offer') | translate"
						[class.pe-4]="showPriceTriangle"
					>
						{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
						@if (showPriceTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataSingle.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
			</header>
			<ul class="p-0">
				<!-- Single-car lots -->
				@for (element of mf.data; track element.vehicle.idVehicle) {
					@let itsClosed = isClosed(element);
					@let currentCurrency = getCurrencySymbol(element.vehicle.currency ?? "EUR", "narrow");
					<li class="py-1">
						<ng-template #carItem>
							<!-- TODO: dovrebbe andare in blank -->
							<!-- TODO: quando è chiusa diventa grigina (vedere figma) -->
							@let extendedPadding = element.lotDTO.flgClickbuy && !element.lotDTO.acceptedOffers;
							<a
								[routerLink]="['/', ClickarPath.PRIVATE, ClickarPath.VEHICLE_MANAGEMENT, ClickarPath.VEHICLE_DETAILS, { idVehicle: element.vehicle.idVehicle }]"
								class="car-list-item car-list-item-linear live-auction text-gray px-2 px-lg-0"
								[ngClass]="{
									'bottom-sheet-padding-extended': extendedPadding && !itsClosed,
									'bottom-sheet-padding': !(extendedPadding || itsClosed),
									'car-item-nodamage': noDamage,
									'car-item-nooffers': noOffers,
									'car-item-blind': itsBlind
								}"
							>
								@let colorClass = itsBlind ? "" : getAuctionColorClass(element.lotDTO);
								<div class="position-absolute top-0 start-0 auction-status-tag {{ colorClass }}"></div>
								<div class="auction-image px-lg-2">
									@if (utils.isEmpty(element.vehicle.appraisalCode)) {
										@if (utils.isEmpty(element.vehicle.idPrincipalPhoto)) {
											<div class="icon no-foto ar-43"></div>
										} @else {
											<img
												loading="lazy"
												class="vehicleImg"
												[src]="utils.getImageUrl(element.vehicle.idPrincipalPhoto)"
											/>
										}
									} @else {
										<button
											type="button"
											class="btn p-0 w-100"
											(click)="$event.preventDefault(); $event.stopPropagation(); openURL(element.vehicle.imagesUrl)"
										>
											<img
												loading="lazy"
												class="vehicleImg"
												alt=""
												[src]="element.vehicle.imageUrl || wcmService.noPhotoUrl"
											/>
										</button>
									}
									<!-- Remove-from-live button for mobile - single lot -->
									<button
										type="button"
										class="btn btn-noborder btn-ico btn-ico-eye-struck-before mt-2 justify-content-center d-lg-none w-100"
										(click)="$event.preventDefault(); $event.stopPropagation(); unobserve(element.lotDTO.idLot)"
									>
										<span class="text-uppercase">{{ "auction.details.removeLive" | translate }}</span>
									</button>
								</div>
								<div
									class="auction-brand py-lg-3 text-center text-lg-start text-truncate"
									[title]="element.vehicle.brand"
								>
									<strong class="text-blue text-xxl text-lg-big">{{ element.vehicle.brand }}</strong>
								</div>
								<div
									class="auction-model py-lg-3 text-center text-lg-start text-truncate"
									[title]="element.vehicle.model"
								>
									<strong class="text-basecolor text-lg text-lg-big">{{ element.vehicle.model }}</strong>
								</div>

								<div class="auction-tag py-3">
									<div class="d-flex flex-row gap-2 flex-wrap flex-lg-nowrap">
										<span class="d-none col text-big d-lg-block">
											{{ element.vehicle.yearMatriculation }}
										</span>
										<span
											class="ck-badge btn-ico btn-ico-simple-calendar-before d-lg-none flex-grow-1"
											data-color="lightgrey"
										>
											{{ element.vehicle.yearMatriculation }}
										</span>

										<ng-template #kmtmp>
											@if (utils.isEmpty(element.vehicle.kilometers) || element.vehicle.kilometers == -1) {
												{{ "vehicle.notAvailable" | translate }}
											} @else {
												{{ element.vehicle.kilometers | number: "1.0-0" : "it-IT" }}
											}
										</ng-template>
										<span
											class="ck-badge btn-ico btn-ico-road-before d-lg-none flex-grow-1"
											data-color="lightgrey"
										>
											<ng-container *ngTemplateOutlet="kmtmp" /> {{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
										</span>

										<span class="d-none col text-big d-lg-block">
											<ng-container *ngTemplateOutlet="kmtmp" />
										</span>
										@if (!noDamage) {
											<ng-template #dmgtmp>
												@if (utils.isEmpty(element.vehicle.damaged) || element.vehicle.damaged == -1) {
													{{ "vehicle.notAvailable" | translate }}
												} @else {
													{{ Math.floor(element.vehicle.damaged) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
												}
											</ng-template>
											<span
												class="ck-badge btn-ico btn-ico-danger-before d-lg-none flex-grow-1"
												data-color="lightgrey"
											>
												<ng-container *ngTemplateOutlet="dmgtmp" />
											</span>
											<span class="d-none col text-big d-lg-block">
												<ng-container *ngTemplateOutlet="dmgtmp" />
											</span>
										}
										<span
											class="ck-badge btn-ico btn-ico-marker-before d-lg-none w-100"
											data-color="lightgrey"
										>
											{{ element.vehicle.locateArea }}
										</span>
										<span class="d-none col text-big d-lg-block">{{ element.vehicle.locateArea }}</span>
									</div>
								</div>
								@if (!(noOffers || itsBlind)) {
									<div class="auction-offersnum pt-3 pb-lg-3">
										<span>
											<span class="d-lg-none">
												{{ "auction.details.offers" | translate }}:
												<strong>{{ element.lotDTO.acceptedOffers ?? 0 }}</strong>
											</span>
											<span class="d-none d-lg-inline text-big">{{ element.lotDTO.acceptedOffers ?? 0 }}</span>
										</span>
									</div>
								}
								@if (!itsBlind) {
									<div class="auction-offer-date pb-3 pt-lg-3">
										@if (element.lotDTO.acceptedOffers) {
											<span class="d-lg-none">
												{{ "auction.live.offerDate" | translate }}:
												<strong>{{ element.lotDTO.dateLastOffer | ckDate: false : false : false : false : true }}</strong>
											</span>
											<span class="d-none d-lg-inline text-big">{{ element.lotDTO.dateLastOffer | ckDate: false : false : false : false : true }}</span>
										}
									</div>
								}
								<div class="auction-offer d-flex justify-content-center py-3 justify-content-lg-start">
									<span class="lh-1 lh-lg-base">
										<strong class="text-huge text-blue text-lg-xl">
											{{ (itsBlind ? element.lotDTO.startPrice : element.lotDTO.actualPrice) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
										</strong>
										@if (!itsBlind) {
											<br />
											<span class="text-sm">
												{{ "auction.details.base" | translate }}:
												<strong class="text-blue">
													{{
														element.reservePrice && utils.isNullOrUndefined(element.lotDTO.basePrice)
															? ("auction.live.reserve" | translate)
															: (element.lotDTO.basePrice | number: "1.0-0" : "it-IT") + " " + currentCurrency
													}}
												</strong>
											</span>
										}
									</span>
								</div>

								<div class="auction-status p-3 p-lg-0 pt-lg-2 pe-lg-1 d-none d-lg-block text-lg-center">
									<ng-container
										*ngTemplateOutlet="
											statusTpl;
											context: {
												$implicit: element.lotDTO.calculatedStatus,
												endDate: element.lotDTO.dateEnd
											}
										"
									>
									</ng-container>
								</div>
								<div class="auction-cardetails pt-lg-2 pb-lg-0 pe-2">
									<strong>{{ "auction.details.version" | translate }}: {{ element.vehicle.version }}</strong>
									<br />
									@if (auction.idMarket === "DE") {
										<strong>{{ "auction.details.frame" | translate }}</strong
										>: {{ element.vehicle.frame }}
									} @else {
										<strong>{{ "auction.details.licensePlate" | translate }}</strong
										>: {{ element.vehicle.licensePlate }}
									}
								</div>
								<div
									class="auction-buttons floating-buttons px-3 py-2 p-lg-0 pt-lg-2 d-flex flex-column flex-lg-row justify-content-end align-items-lg-end cursor-default"
									[ngClass]="itsClosed ? 'd-none d-lg-flex' : 'd-flex'"
									(click)="$event.preventDefault(); $event.stopPropagation()"
								>
									@if (!itsClosed) {
										<div class="mb-2 mb-lg-0">
											<div class="text-blue pb-2 fw-bold text-sm">
												{{ "auction.live.yourMaxOffer" | translate }}:
												@if (element.lotDTO.userMaxOffer) {
													{{ element.lotDTO.userMaxOffer | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
												}
											</div>
											<div class="d-flex flex-column flex-lg-row">
												@let minRelaunchPrice = auctionService.getMinRelaunchPrice(element.lotDTO, auction, itsBlind);
												<input
													type="number"
													class="mb-3 mb-lg-0 defaultInput"
													(click)="$event.preventDefault(); $event.stopPropagation()"
													[(ngModel)]="element.offer"
													#offerModel="ngModel"
													placeholder="{{ minRelaunchPrice | number: '1.0-0' : 'it-IT' }} {{ currentCurrency }} {{ 'auction.live.orMore' | translate }}"
													[min]="minRelaunchPrice"
													required
												/>
												<div class="d-lg-none row gx-0 row-cols-3 mb-3">
													<div class="pe-1 pe-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="element.offer = minRelaunchPrice"
														>
															{{ minRelaunchPrice | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
													<div class="px-1 px-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="element.offer = minRelaunchPrice + auction.minRelaunch"
														>
															{{ minRelaunchPrice + auction.minRelaunch | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
													<div class="ps-1 ps-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="element.offer = minRelaunchPrice + 2 * auction.minRelaunch"
														>
															{{ minRelaunchPrice + 2 * auction.minRelaunch | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
												</div>
												<button
													type="button"
													class="btn btn-red text-uppercase ms-lg-3"
													(click)="$event.preventDefault(); $event.stopPropagation(); makeOffer(element)"
													[disabled]="offerModel.dirty && offerModel.invalid"
												>
													{{ "auction.live.placeBid" | translate }}
												</button>
											</div>
										</div>
										@if (element.lotDTO.flgClickbuy && !element.lotDTO.acceptedOffers) {
											<div class="d-lg-none text-center sideLines pb-2 py-lg-3 text-sm">
												<span>
													{{ "auction.live.orBetweenCTAs" | translate }}
												</span>
											</div>

											<button
												type="button"
												class="btn btn-outline ms-lg-3 mb-3 mb-lg-0 text-uppercase"
												(click)="$event.preventDefault(); $event.stopPropagation(); clickAndBuy(element)"
											>
												{{ "auction.details.buyNowFor" | translate }}
												{{ element.lotDTO.clickbuyPrice | number: "1.0-0" : "it-IT" }}
												{{ currentCurrency }}
											</button>
										}
										<!-- Remove-from-live button for desktop - single lot -->
										<button
											type="button"
											title="{{ 'auction.details.removeLive' | translate }}"
											class="btn btn-noborder btn-ico btn-ico-eye-struck-before ms-3 justify-content-center d-none d-lg-inline-flex"
											(click)="$event.preventDefault(); $event.stopPropagation(); unobserve(element.lotDTO.idLot)"
										></button>
									}
								</div>
							</a>
						</ng-template>
						@let colorClass = itsBlind ? "" : getAuctionColorClass(element.lotDTO);
						<div
							[attr.idLot]="element.lotDTO?.idLot"
							#singleLotRow
							class="d-none d-lg-block rounded-3 ck-shadow auction-status-border p-2 {{ colorClass }}"
							[class.closed-list-item]="itsClosed"
						>
							<ng-container *ngTemplateOutlet="carItem" />
						</div>
						<div class="live-auction d-lg-none">
							<button
								type="button"
								class="auction-recap d-grid w-100 text-start auction-status-border {{ colorClass }}"
								[class.closed-list-item]="itsClosed"
								(click)="openLotDetail(element)"
								[attr.idLot]="element.lotDTO?.idLot"
								#singleLotRow
							>
								<div class="auction-image d-flex flex-column justify-content-center pe-1 pe-sm-2">
									@if (utils.isEmpty(element.vehicle.appraisalCode)) {
										@if (utils.isEmpty(element.vehicle.idPrincipalPhoto)) {
											<div class="icon no-foto ar-43"></div>
										} @else {
											<img
												loading="lazy"
												class="vehicleImg"
												[src]="utils.getImageUrl(element.vehicle.idPrincipalPhoto)"
											/>
										}
									} @else {
										<img
											loading="lazy"
											class="vehicleImg"
											alt=""
											[src]="element.vehicle.imageUrl || wcmService.noPhotoUrl"
										/>
									}
								</div>
								<div
									class="auction-brand text-truncate px-1 px-sm-3 text-sm py-2"
									[title]="element.vehicle.brand"
								>
									<strong class="text-blue">{{ element.vehicle.brand }}</strong>
								</div>
								<div
									class="auction-model text-truncate px-1 px-sm-3 text-sm py-2"
									[title]="element.vehicle.model"
								>
									<strong>{{ element.vehicle.model }}</strong>
								</div>
								<div class="auction-cardetails text-xs px-1 py-2">
									{{ element.vehicle.version }}
								</div>
								<div class="auction-offer d-flex justify-content-center align-items-center px-1 px-sm-3 py-2">
									<span class="lh-1">
										<strong class="text-big text-blue">
											{{ (itsBlind ? element.lotDTO.startPrice : element.lotDTO.actualPrice) | number: "1.0-0" : "it-IT" }}
											{{ currentCurrency }}
										</strong>
										<!-- @if (!itsBlind) {
											<br /><span class="text-xs"
												>{{ "auction.details.base" | translate }}:
												<strong class="text-blue"
													>{{
													element.reservePrice && utils.isNullOrUndefined(element.lotDTO.basePrice)
														? ("auction.live.reserve" | translate)
														: (element.lotDTO.basePrice | number: "1.0-0" : "it-IT")e + " " + currentCurrency
													}}
												</strong>
											</span>
										} -->
									</span>
								</div>
								<div class="auction-status py-2 text-end d-flex align-items-center">
									<ng-container
										*ngTemplateOutlet="
											statusTpl;
											context: {
												$implicit: element.lotDTO.calculatedStatus,
												endDate: element.lotDTO.dateEnd
											}
										"
									>
									</ng-container>
								</div>
							</button>
						</div>
						<!-- TODO: sarebbe da animare anche la card nello sheet (e il tag in alto) al blink, ma la card è più piccola del bottom-sheet, per cui è da pensare come farla -->
						<bottom-sheet
							class="d-lg-none"
							[open]="openLot === element"
							[template]="carItem"
							(closeClicked)="closeLotDetail()"
						/>
					</li>
				}
			</ul>
		</article>
	}
	@if (multipleLot?.length) {
		<article
			#target
			[mfData]="multipleLot"
			#mf="appDataTable"
			[mfSortOrder]="tableDataMulti.sortOrder"
			(mfSortOrderChange)="saveSortOrder(true, $event)"
			[mfSortBy]="tableDataMulti.orderBy"
			(mfSortByChange)="saveOrderBy(true, $event)"
		>
			@let noFieldSelected = !tableDataMulti.orderBy;
			<header
				class="lot-list-heading live-auction sticky-list-heading stickyTop-l3 bg-white rounded-top-3 ck-fixed-shadow d-none d-lg-grid px-3 mb-3"
				[ngClass]="{
					'car-item-nooffers': noOffers,
					'car-item-blind': itsBlind
				}"
			>
				<div class="py-1 min-width-0">
					@let showStatusTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.calculatedStatus";
					<app-default-sorter
						by="lotDTO.calculatedStatus"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.status' | translate"
						[class.pe-4]="showStatusTriangle"
					>
						{{ "auction.details.status" | translate }}
						@if (showStatusTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				<div class="py-1 min-width-0">
					@let showLotTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.idLot";
					<app-default-sorter
						by="lotDTO.idLot"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="'auction.details.id' | translate"
						[class.pe-4]="showLotTriangle"
					>
						{{ "auction.details.id" | translate }}
						@if (showLotTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
				@if (!(noOffers || itsBlind)) {
					<div class="py-1 min-width-0">
						@let showOffersTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.acceptedOffers";
						<app-default-sorter
							by="lotDTO.acceptedOffers"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.details.offerNumber' | translate"
							[class.pe-4]="showOffersTriangle"
						>
							{{ "auction.details.offerNumber" | translate }}
							@if (showOffersTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				}
				@if (!itsBlind) {
					<div class="py-1 min-width-0">
						@let showOfferTriangle = noFieldSelected || tableDataMulti.orderBy === "lotDTO.dateLastOffer";
						<app-default-sorter
							by="lotDTO.dateLastOffer"
							class="d-inline-block align-middle mw-100 position-relative text-truncate"
							[title]="'auction.live.offerDate' | translate"
							[class.pe-4]="showOfferTriangle"
						>
							{{ "auction.live.offerDate" | translate }}
							@if (showOfferTriangle) {
								<div
									class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
									[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
								></div>
							}
						</app-default-sorter>
					</div>
				}
				<div class="py-1 min-width-0">
					@let targetPrice = itsBlind ? "lotDTO.startPrice" : "lotDTO.actualPrice";
					@let showPriceTriangle = noFieldSelected || tableDataMulti.orderBy === targetPrice;
					<app-default-sorter
						[by]="targetPrice"
						class="d-inline-block align-middle mw-100 position-relative text-truncate"
						[title]="(itsBlind ? 'auction.live.startPrice' : 'auction.details.offer') | translate"
						[class.pe-4]="showPriceTriangle"
					>
						{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }}
						@if (showPriceTriangle) {
							<div
								class="position-absolute end-0 top-50 translate-middle-y triangle me-1"
								[ngClass]="'triangle-' + (tableDataMulti.sortOrder === 'asc' ? 'up' : 'down')"
							></div>
						}
					</app-default-sorter>
				</div>
			</header>
			<ul class="p-0">
				<!-- Multiple-car lots -->
				@for (multiple of mf.data; track multiple.lotDTO.idLot) {
					@let itsClosed = isClosed(multiple);
					@let currentCurrency = getCurrencySymbol(multiple.vehiclesDTO[0]?.currency ?? "EUR", "narrow");

					<li class="py-1">
						<ng-template #lotItem>
							@let extendedPadding = !itsClosed && multiple.lotDTO.flgClickbuy && !multiple.lotDTO.acceptedOffers;
							<div
								class="lot-list-item live-auction text-gray"
								[ngClass]="{
									'bottom-sheet-padding-extended': extendedPadding && !itsClosed,
									'bottom-sheet-padding': !(extendedPadding || itsClosed),
									'car-item-nooffers': noOffers,
									'car-item-blind': itsBlind
								}"
							>
								@let colorClass = itsBlind ? "" : getAuctionColorClass(multiple.lotDTO);
								<div class="position-absolute top-0 start-0 auction-status-tag {{ colorClass }}"></div>
								<div class="auction-vendor-logo pb-3 px-lg-2">
									@if (auction.flgMultiAuctioneer) {
										@if (!utils.isNullOrUndefined(logoAuctioneer)) {
											<a
												href="#"
												(click)="$event.preventDefault(); goToAuctioneerPresentation(logoAuctioneer[multiple.provenance]?.idLogo)"
											>
												<img
													loading="lazy"
													[src]="utils.getImageUrl(logoAuctioneer[multiple.provenance]?.idLogo)"
													alt=""
												/>
											</a>
										}
									} @else {
										<a
											href="#"
											(click)="$event.preventDefault(); goToAuctioneerPresentation()"
										>
											<img
												loading="lazy"
												[src]="utils.getImageUrl(auction?.smallLogo)"
												alt=""
											/>
										</a>
									}
								</div>
								<div class="auction-lot-name d-flex pb-3 align-items-center">
									<strong class="text-big text-blue">{{ "auction.details.lot" | translate }} {{ multiple.lotDTO.idLot }} </strong>
								</div>
								@if (!(noOffers || itsBlind)) {
									<div class="auction-offersnum p-3 pb-0 p-lg-0 pb-lg-3 d-flex align-items-lg-center">
										<span>
											<span class="d-lg-none">
												{{ "auction.details.offers" | translate }}:
												<strong>{{ multiple.lotDTO.acceptedOffers ?? 0 }}</strong>
											</span>
											<span class="d-none d-lg-inline text-big">{{ multiple.lotDTO.acceptedOffers ?? 0 }}</span>
										</span>
									</div>
								}
								@if (!itsBlind) {
									<div class="auction-offer-date px-3 pb-3 px-lg-0 pt-lg-3">
										@if (multiple.lotDTO.acceptedOffers) {
											<span class="d-lg-none">
												{{ "auction.live.offerDate" | translate }}:
												<strong>{{ multiple.lotDTO.dateLastOffer | ckDate: false : false : false : false : true }}</strong>
											</span>
											<span class="d-none d-lg-inline text-big">{{ multiple.lotDTO.dateLastOffer | ckDate: false : false : false : false : true }}</span>
										}
									</div>
								}
								<div class="auction-offer">
									<div class="d-flex align-items-lg-center justify-content-center justify-content-lg-start p-3 p-lg-0 pb-lg-3">
										<span class="d-lg-none text-sm fw-bold pe-1 pe-lg-0">{{ (itsBlind ? "auction.live.startPrice" : "auction.details.offer") | translate }} </span>
										<span class="lh-1 lh-lg-base">
											<strong class="text-huge text-lg-xl text-blue">
												{{ (itsBlind ? multiple.lotDTO.startPrice : multiple.lotDTO.actualPrice) | number: "1.0-0" : "it-IT" }}
												{{ currentCurrency }}
											</strong>
											@if (!itsBlind) {
												<span class="d-none d-lg-inline">&nbsp;&nbsp;</span><br class="d-lg-none" />{{ "auction.details.base" | translate }}:
												<strong class="text-blue">{{
													multiple.lotDTO.reservePrice || utils.isNullOrUndefined(multiple.lotDTO.basePrice)
														? ("auction.live.reserve" | translate)
														: (multiple.lotDTO.basePrice | number: "1.0-0" : "it-IT") + " " + currentCurrency
												}}</strong>
											}
										</span>
									</div>
									<!-- Remove-from-live button for mobile - multiple lot -->
									<button
										type="button"
										class="btn btn-noborder btn-ico btn-ico-eye-struck-before justify-content-center d-lg-none w-100"
										(click)="$event.preventDefault(); $event.stopPropagation(); unobserve(multiple.lotDTO.idLot)"
									>
										<span class="text-uppercase">{{ "auction.details.removeLive" | translate }}</span>
									</button>
								</div>
								<div class="auction-status p-3 p-lg-0 pt-lg-2 d-none d-lg-block text-lg-center">
									<ng-container
										*ngTemplateOutlet="
											statusTpl;
											context: {
												$implicit: multiple.lotDTO.calculatedStatus,
												endDate: multiple.lotDTO.dateEnd
											}
										"
									>
									</ng-container>
								</div>
								<div class="auction-showcars p-3 p-lg-0 pt-lg-2 pe-lg-2">
									<button
										type="button"
										class="btn btn-outline d-none d-lg-inline"
										(click)="$event.preventDefault(); $event.stopPropagation(); (isCarListOpen(multiple.lotDTO.idLot) ? closeCarList : openCarList)(multiple.lotDTO.idLot)"
									>
										{{
											(isCarListOpen(multiple.lotDTO.idLot) ? "auction.details.hideLotVehicles" : "auction.details.showNLotVehicles")
												| translate: { carsnum: multiple.vehiclesDTO.length }
										}}
									</button>
									<span class="d-lg-none">{{ multiple.vehiclesDTO.length }} {{ "auction.live.lotVehicles" | translate }} </span>
								</div>

								<ng-template #carsList>
									<header
										class="car-list-heading rounded-top-3 d-none d-lg-grid mb-3 px-2 px-sm-3"
										[class.car-item-nodamage]="noDamage"
									>
										<div></div>
										<div>
											{{ "auction.details.brand" | translate }}
										</div>
										<div>
											{{ "auction.details.model" | translate }}
										</div>
										<div>
											{{ "auction.details.year" | translate }}
										</div>
										<div>
											{{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
										</div>
										@if (!noDamage) {
											<div>
												{{ "auction.details.damage" | translate }}
											</div>
										}
										<div>
											{{ "auction.details.locateArea" | translate }}
										</div>
									</header>
									<ul class="p-0">
										@for (ele of multiple.vehiclesDTO; track ele.idVehicle) {
											<li class="mb-2">
												<!-- TODO: dovrebbe andare in blank -->
												<!-- TODO: quando è chiusa diventa grigina (vedere figma) -->
												<a
													[routerLink]="['/', ClickarPath.PRIVATE, ClickarPath.VEHICLE_MANAGEMENT, ClickarPath.VEHICLE_DETAILS, { idVehicle: ele.idVehicle }]"
													class="car-list-item ck-fixed-shadow rounded-3 text-gray py-3 px-2 px-sm-3"
													[class.car-item-nodamage]="noDamage"
												>
													<div class="auction-image pe-2">
														@if (utils.isEmpty(ele.appraisalCode)) {
															@if (utils.isEmpty(ele.idPrincipalPhoto)) {
																<div class="icon no-foto ar-43"></div>
															} @else {
																<img
																	loading="lazy"
																	class="vehicleImg"
																	[src]="utils.getImageUrl(ele.idPrincipalPhoto)"
																/>
															}
														} @else {
															<button
																type="button"
																class="btn p-0 w-100"
																(click)="$event.preventDefault(); $event.stopPropagation(); openURL(ele.imagesUrl)"
															>
																<img
																	loading="lazy"
																	class="vehicleImg"
																	[src]="ele.imageUrl || wcmService.noPhotoUrl"
																/>
															</button>
														}
													</div>
													<div
														class="auction-brand text-blue py-2 text-truncate"
														[title]="ele.brand"
													>
														<strong>{{ ele.brand }}</strong>
													</div>
													<div
														class="auction-model py-2 text-truncate"
														[title]="ele.model"
													>
														{{ ele.model }}
													</div>
													<div class="auction-cardetails py-2">
														<strong>{{ "auction.details.version" | translate }}: {{ ele.version }}</strong>
														<br />
														@if (auction.idMarket === "DE") {
															<strong> {{ "auction.details.frame" | translate }}</strong
															>: {{ ele.vehicle.frame }}
														} @else {
															<strong>{{ "auction.details.licensePlate" | translate }}</strong
															>: {{ ele.licensePlate }}
														}
													</div>
													<div class="auction-tag py-2">
														<div class="d-flex flex-row gap-2 flex-wrap flex-lg-nowrap py-2 py-lg-0">
															<span
																class="ck-badge btn-ico btn-ico-simple-calendar-before d-lg-none flex-grow-1"
																data-color="lightgrey"
															>
																{{ ele.yearMatriculation }}
															</span>
															<span class="d-none d-lg-block col">
																{{ ele.yearMatriculation }}
															</span>
															<ng-template #kmtmp>
																@if (utils.isEmpty(ele.kilometers) || ele.kilometers == -1) {
																	{{ "vehicle.notAvailable" | translate }}
																} @else {
																	{{ ele.kilometers | number: "1.0-0" : "it-IT" }}
																}
															</ng-template>
															<span
																class="ck-badge btn-ico btn-ico-road-before d-lg-none flex-grow-1"
																data-color="lightgrey"
															>
																<ng-container *ngTemplateOutlet="kmtmp" />
																{{ (auction.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
															</span>
															<span class="d-none d-lg-block col">
																<ng-container *ngTemplateOutlet="kmtmp" />
															</span>
															@if (!noDamage) {
																<ng-template #dmgtmp>
																	@if (utils.isEmpty(ele.damaged) || ele?.damaged == -1) {
																		{{ "vehicle.notAvailable" | translate }}
																	} @else {
																		{{ Math.floor(ele?.damaged) | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
																	}
																</ng-template>
																<span
																	class="ck-badge btn-ico btn-ico-danger-before d-lg-none flex-grow-1"
																	data-color="lightgrey"
																>
																	<ng-container *ngTemplateOutlet="dmgtmp" />
																</span>
																<span class="d-none d-lg-block col">
																	<ng-container *ngTemplateOutlet="dmgtmp" />
																</span>
															}
															<span
																class="ck-badge btn-ico btn-ico-marker-before d-lg-none w-100"
																data-color="lightgrey"
															>
																{{ ele.locateArea }}
															</span>
															<span class="d-none d-lg-block col">{{ ele.locateArea }} </span>
														</div>
													</div>
												</a>
											</li>
										}
									</ul>
								</ng-template>
								@if (isCarListOpen(multiple.lotDTO.idLot)) {
									<div
										class="auction-cars-list d-none d-lg-grid"
										animate.enter="accordion-enter"
										animate.leave="accordion-leave"
									>
										<div
											class="p-lg-3 rounded-3 mt-lg-3 bg-gray"
											[style.minHeight]="0"
										>
											<!-- NOTE: min-height for the animation -->
											<ng-container *ngTemplateOutlet="carsList" />
										</div>
									</div>
								}
								<div class="auction-cars-list d-grid d-lg-none">
									<ng-container *ngTemplateOutlet="carsList" />
								</div>
								<div
									class="auction-buttons floating-buttons px-3 py-2 p-lg-0 pt-lg-2 d-flex flex-column flex-lg-row justify-content-end align-items-lg-end cursor-default"
									[ngClass]="itsClosed ? 'd-none d-lg-flex' : 'd-flex'"
									(click)="$event.preventDefault(); $event.stopPropagation()"
								>
									@if (!itsClosed) {
										<div class="mb-3 mb-lg-0">
											<div class="text-blue pb-2 fw-bold text-sm">
												{{ "auction.live.yourMaxOffer" | translate }}:
												@if (multiple.lotDTO.userMaxOffer) {
													{{ multiple.lotDTO.userMaxOffer | number: "1.0-0" : "it-IT" }} {{ currentCurrency }}
												}
											</div>
											<div class="d-flex flex-column flex-lg-row">
												@let minRelaunch = auctionService.getMinRelaunchPrice(multiple.lotDTO, auction, itsBlind);
												<input
													type="number"
													class="mb-3 mb-lg-0 defaultInput"
													(click)="$event.preventDefault(); $event.stopPropagation()"
													[(ngModel)]="multiple.offer"
													#offerModel="ngModel"
													placeholder="{{ minRelaunch | number: '1.0-0' : 'it-IT' }} {{ currentCurrency }} {{ 'auction.live.orMore' | translate }}"
													[min]="minRelaunch"
													required
												/>
												<div class="d-lg-none row gx-0 row-cols-3 mb-3">
													<div class="pe-1 pe-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="multiple.offer = minRelaunch"
														>
															{{ minRelaunch | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
													<div class="px-1 px-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="multiple.offer = minRelaunch + auction.minRelaunch"
														>
															{{ minRelaunch + auction.minRelaunch | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
													<div class="ps-1 ps-sm-2">
														<button
															class="btn btn-outline px-1 px-md-2 w-100"
															(click)="multiple.offer = minRelaunch + 2 * auction.minRelaunch"
														>
															{{ minRelaunch + 2 * auction.minRelaunch | number: "1.0-0" : "it-IT" }}
															{{ currentCurrency }}
														</button>
													</div>
												</div>
												<button
													type="button"
													class="btn btn-red text-uppercase ms-lg-3"
													(click)="$event.preventDefault(); $event.stopPropagation(); makeOffer(multiple)"
													[disabled]="offerModel.dirty && offerModel.invalid"
												>
													{{ "auction.live.placeBid" | translate }}
												</button>
											</div>
										</div>
										@if (multiple.lotDTO.flgClickbuy && !multiple.lotDTO.acceptedOffers) {
											<div class="d-lg-none text-center sideLines pb-2 py-lg-3 text-sm">
												<span>
													{{ "auction.live.orBetweenCTAs" | translate }}
												</span>
											</div>
											<button
												type="button"
												class="btn btn-outline ms-lg-3 mb-3 mb-lg-0 text-uppercase"
												(click)="$event.preventDefault(); $event.stopPropagation(); clickAndBuy(multiple)"
											>
												{{ "auction.details.buyNowFor" | translate }}
												{{ multiple.lotDTO.clickbuyPrice | number: "1.0-0" : "it-IT" }}
												{{ currentCurrency }}
											</button>
										}
									}
									<!-- Remove-from-live button for desktop - multiple lot -->
									<button
										type="button"
										title="{{ 'auction.details.removeLive' | translate }}"
										class="btn btn-noborder btn-ico btn-ico-eye-struck-before ms-3 justify-content-center d-none d-lg-inline-flex"
										(click)="$event.preventDefault(); $event.stopPropagation(); unobserve(multiple.lotDTO.idLot)"
									></button>
								</div>
							</div>
						</ng-template>
						@let colorClass = itsBlind ? "" : getAuctionColorClass(multiple.lotDTO);
						<div
							[attr.idLot]="multiple.lotDTO.idLot"
							#multipleLotRow
							class="d-none d-lg-block rounded-3 ck-shadow auction-status-border p-2 {{ colorClass }}"
							[class.closed-list-item]="itsClosed"
						>
							<ng-container *ngTemplateOutlet="lotItem" />
						</div>
						<div class="live-auction d-lg-none">
							<button
								type="button"
								class="lot-recap d-grid w-100 text-start auction-status-border {{ colorClass }}"
								[class.closed-list-item]="itsClosed"
								(click)="openLotDetail(multiple)"
								[attr.idLot]="multiple.lotDTO?.idLot"
								#multipleLotRow
							>
								<div class="auction-vendor-logo pb-3 pe-1">
									@if (auction.flgMultiAuctioneer) {
										@if (!utils.isNullOrUndefined(logoAuctioneer)) {
											<a
												href="#"
												(click)="$event.preventDefault(); goToAuctioneerPresentation(logoAuctioneer[auction.provenances[0]]?.idLogo)"
											>
												<!-- TODO: verificare che auction.provenances[0] sia corretto -->
												<img
													loading="lazy"
													[src]="utils.getImageUrl(logoAuctioneer[auction.provenances[0]]?.idLogo)"
													alt=""
												/>
											</a>
										}
									} @else {
										<a
											href="#"
											(click)="$event.preventDefault(); goToAuctioneerPresentation()"
										>
											<img
												loading="lazy"
												[src]="utils.getImageUrl(auction?.smallLogo)"
												alt=""
											/>
										</a>
									}
								</div>
								<div
									class="auction-lot-name text-truncate px-1 px-sm-3 py-2 text-sm"
									title="{{ 'auction.details.lot' | translate }} {{ multiple.lotDTO.idLot }}"
								>
									<strong class="text-blue">{{ "auction.details.lot" | translate }} {{ multiple.lotDTO.idLot }} </strong>
								</div>
								<div class="auction-cardetails text-xs px-1 py-2">{{ multiple.vehiclesDTO.length }} {{ "auction.live.lotVehicles" | translate }}</div>
								<div class="auction-offer d-flex justify-content-center align-items-center px-1 px-sm-3 py-2">
									<span class="lh-1"
										><strong class="text-big text-blue">
											{{ (itsBlind ? multiple.lotDTO.startPrice : multiple.lotDTO.actualPrice) | number: "1.0-0" : "it-IT" }}
											{{ currentCurrency }}
										</strong>
										<!-- @if (!itsBlind) {
											<br /><span class="text-xs"
												>{{ "auction.details.base" | translate }}:
												<strong class="text-blue">{{
													multiple.lotDTO.reservePrice && utils.isNullOrUndefined(multiple.lotDTO.basePrice)
														? ("auction.live.reserve" | translate)
														: (multiple.lotDTO.basePrice | number: "1.0-0" : "it-IT")
												}}</strong>
											</span>
										} -->
									</span>
								</div>
								<div class="auction-status py-2 text-end d-flex align-items-center">
									<ng-container
										*ngTemplateOutlet="
											statusTpl;
											context: {
												$implicit: multiple.lotDTO.calculatedStatus,
												endDate: multiple.lotDTO.dateEnd
											}
										"
									>
									</ng-container>
								</div>
							</button>
						</div>
						<!-- TODO: sarebbe da animare anche la card nello sheet (e il tag in alto) al blink, ma la card è più piccola del bottom-sheet, per cui è da pensare come farla -->
						<bottom-sheet
							class="d-lg-none"
							[open]="openLot === multiple"
							[template]="lotItem"
							(closeClicked)="closeLotDetail()"
						/>
					</li>
				}
			</ul>
		</article>
	}
</section>